<script>
    import 'photoswipe/dist/photoswipe.css'
    import 'photoswipe/dist/default-skin/default-skin.css'
    import { setContext } from 'svelte'
    import PhotoSwipe from 'photoswipe';
    import PhotoSwipeUI_Default from 'photoswipe/dist/photoswipe-ui-default'
	import { IMAGE_SIZES as SIZES } from '../../models'

    const options = {
		// Core options
		closeOnScroll: false,
		closeOnVerticalDrag: false,
		showHideOpacity:true,
		loop: false,
		pinchToClose: false, // very messy

		// Default UI options
		shareEl: false,
		clickToCloseNonZoomable: false,
		tapToClose: true,
		tapToToggleControls: false
	}

    let photoswipe
    let photoswipeContainer	

	export const open = (images, focusedImage, onClose) => {
		const photoswipeImages = images.map((img) => {
			const size = img.getSize(SIZES.LG)
			return { 
				src: size.src, 
				w: size.width, 
				h: size.height,
				title: img.credit ? `Photo: ${img.credit}` : null
			}
		})

		photoswipe = new PhotoSwipe( photoswipeContainer, PhotoSwipeUI_Default, photoswipeImages, options)
        
		if (onClose) photoswipe.listen('close', onClose)

        if (focusedImage) {
            photoswipe.options.index = images.findIndex(img => img === focusedImage)
        }

        photoswipe.init()	
	}

	export const close = () => {
		photoswipe && photoswipe.close()
	}

	setContext('photoswipe', { open, close })
</script>

<slot />
<!-- Root element of PhotoSwipe. Must have class pswp. -->
<div class="pswp" tabindex="-1" role="dialog" aria-hidden="true" bind:this={photoswipeContainer}>

	<!-- Background of PhotoSwipe. 
		 It's a separate element as animating opacity is faster than rgba(). -->
    <div class="pswp__bg"></div>

	<!-- Slides wrapper with overflow:hidden. -->
    <div class="pswp__scroll-wrap">

		<!-- Container that holds slides. 
			PhotoSwipe keeps only 3 of them in the DOM to save memory.
			Don't modify these 3 pswp__item elements, data is added later on. -->
		<div class="pswp__container">
			<div class="pswp__item"></div>
			<div class="pswp__item"></div>
			<div class="pswp__item"></div>
		</div>

		<!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
		<div class="pswp__ui pswp__ui--hidden">

			<div class="pswp__top-bar">

				<!--  Controls are self-explanatory. Order can be changed. -->
				
				<div class="pswp__counter"></div>

				<button class="pswp__button pswp__button--close" title="Close (Esc)"></button>

				<button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>

				<button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>

				<!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
				<!-- element will get class pswp__preloader--active when preloader is running -->
				<div class="pswp__preloader">
					<div class="pswp__preloader__icn">
					  <div class="pswp__preloader__cut">
					    <div class="pswp__preloader__donut"></div>
					  </div>
					</div>
				</div>
			</div>

			<button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)">
			</button>
			
			<button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)">
			</button>

			<div class="pswp__caption">
				<div class="pswp__caption__center pswp__caption__right"></div>
			</div>

	    </div>

	</div>

</div>


<style>
	.pswp__caption__center.pswp__caption__right {
		margin-right: 0;
		text-align: right;
		padding-right: 2em;
	}
</style>
